import { h3SetToMultiPolygonFeature } from 'geojson2h3';
import { createSelector } from 'reselect';

export const selectObstacles = state => state.routePlanner.obstacles;
export const selectObstaclesKey = state => state.routePlanner.obstaclesKey;
export const selectObstacleHex = createSelector(selectObstacles, obstacles => {
  try {
    const obstacleFeatures = Object.keys(obstacles).map(obType => {
      const feature = h3SetToMultiPolygonFeature(obstacles[obType]);
      return { type: obType, feature };
    });
    return obstacleFeatures;
  } catch (err) {
    return [];
  }
});
